module.exports = __webpack_public_path__ + "files/cb145da624bb2c552c1ea730c77737b4.png";